import {
	Directive,
	ElementRef,
	Input,
	OnChanges,
	OnDestroy,
	Renderer2,
	SimpleChanges,
} from '@angular/core';

@Directive({
	selector: '[sprBadge]',
})
export class BadgeDirective implements OnChanges, OnDestroy {
	@Input('sprBadge') content: string | number;

	@Input('badgeBackgroundColor') backgroundColor: string;

	private _badgeElement: HTMLElement | undefined;

	constructor(
		private _elementRef: ElementRef<HTMLElement>,
		private _renderer: Renderer2
	) {}

	ngOnChanges(changes: SimpleChanges) {
		this._updateTextContent();
	}

	ngOnDestroy() {
		if (this._badgeElement && this._renderer.destroyNode) {
			this._renderer.destroyNode(this._badgeElement);
		}
	}

	private _updateTextContent(): HTMLSpanElement {
		if (!this._badgeElement) {
			this._badgeElement = this._createBadgeElement();
		} else {
			this._badgeElement.textContent = String(this.content);
		}

		if (!!this.content) {
			this._renderer.removeClass(this._badgeElement, 'hidden');
		} else {
			this._renderer.addClass(this._badgeElement, 'hidden');
		}

		return this._badgeElement;
	}

	private _createBadgeElement(): HTMLElement {
		const badgeElement = this._renderer.createElement('span');
		badgeElement.textContent = this.content;

		this._renderer.setStyle(
			this._elementRef.nativeElement,
			'position',
			'relative'
		);
		this._renderer.appendChild(this._elementRef.nativeElement, badgeElement);

		this._renderer.addClass(
			badgeElement,
			!this.backgroundColor ? 'p-background-color-primary' : this.backgroundColor
		);
		this._renderer.addClass(badgeElement, 'p-color-primary-text');
		this._renderer.addClass(badgeElement, 'spr-badge');

		return badgeElement;
	}
}
